export default "__VITE_ASSET__BuLXUjAf__"